import { Box, BoxProps } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

// ----------------------------------------------------------------------

interface Props extends BoxProps {
  disabledLink?: boolean;
  width?: number;
  height?: number;
}

export default function Logo({
  disabledLink = false,
  width = 80,
  height = 80,
  sx,
}: Props) {
  const logo = (
    <Box sx={{ width, height, ...sx }}>
      <svg
        width={width || 48}
        height={height || 48}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.15"
          y="0.15"
          width="47.7"
          height="47.7"
          rx="11.85"
          fill="black"
        />
        <rect
          x="0.15"
          y="0.15"
          width="47.7"
          height="47.7"
          rx="11.85"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.3628 32.7605C26.3631 32.7602 26.3634 32.7598 28.5503 34.4705C30.7373 36.1811 30.7377 36.1806 30.7381 36.1801L30.7423 36.1748L30.7517 36.1626C30.7595 36.1526 30.7702 36.1389 30.7836 36.1214C30.8106 36.0865 30.8488 36.0368 30.8972 35.9731C30.9941 35.8457 31.1322 35.6622 31.304 35.4289C31.6474 34.9628 32.1269 34.2957 32.6819 33.4786C33.7866 31.8524 35.2153 29.5953 36.4652 27.122C37.6983 24.682 38.8452 21.8621 39.2492 19.1423C39.6508 16.4387 39.3793 13.2975 37.0416 10.9599C34.704 8.62222 31.5628 8.35075 28.8592 8.75233C26.1394 9.15632 23.3195 10.3032 20.8795 11.5363C18.4062 12.7862 16.1491 14.2149 14.5229 15.3196C13.7058 15.8746 13.0387 16.3541 12.5726 16.6975C12.3393 16.8693 12.1558 17.0074 12.0285 17.1043C11.9648 17.1527 11.915 17.1909 11.8801 17.2179C11.8626 17.2314 11.8489 17.242 11.8389 17.2498L11.8267 17.2592L11.8214 17.2634C11.8209 17.2638 11.8204 17.2642 13.531 19.4512C15.2417 21.6381 15.2413 21.6384 15.241 21.6387L15.2461 21.6347C15.2513 21.6307 15.2602 21.6238 15.2727 21.6141C15.2977 21.5948 15.3372 21.5645 15.3903 21.5241C15.4965 21.4433 15.6571 21.3224 15.8659 21.1686C16.2839 20.8607 16.8928 20.4228 17.6431 19.9131C19.1516 18.8885 21.1949 17.5988 23.3842 16.4924C25.6068 15.3692 27.8115 14.522 29.6751 14.2451C31.5548 13.9659 32.5556 14.327 33.115 14.8865C33.6745 15.4459 34.0356 16.4467 33.7564 18.3264C33.4796 20.19 32.6323 22.3947 31.5091 24.6173C30.4027 26.8066 29.1131 28.8499 28.0884 30.3584C27.5787 31.1087 27.1408 31.7176 26.833 32.1356C26.6792 32.3444 26.5582 32.505 26.4774 32.6112C26.437 32.6643 26.4067 32.7038 26.3874 32.7288C26.3777 32.7413 26.3708 32.7502 26.3668 32.7554L26.3628 32.7605Z"
          fill="white"
        />
        <path
          d="M13.1381 26.9113C10.9695 29.0799 8.42618 39.4764 8.42618 39.4764C8.42618 39.4764 18.8227 36.9331 20.9914 34.7645C23.16 32.5959 23.16 29.0799 20.9914 26.9113C18.8227 24.7427 15.3067 24.7427 13.1381 26.9113Z"
          fill="white"
        />
        <rect
          x="0.15"
          y="0.15"
          width="47.7"
          height="47.7"
          rx="11.85"
          stroke="black"
          strokeWidth="0.3"
        />
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="/">{logo}</RouterLink>;
}
